import {GET_MANAGEMENT_START} from "../../types";

export const management = (payload) => ({
  type: GET_MANAGEMENT_START,
  payload,
});
